// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const commentsHistoryConfig = {
    title: 'chart.linkedin.comments_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.linkedin.comments_history_name',
        avg: 'chart.linkedin.comments_history_avg'
    },
    id: 'comments_history',
    color: {
        value: 'yellow',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.facebook.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
